@if (imageUrl(); as url) {
  <div class="image-wrapper">
    <img [ngSrc]="url" [width]="imageWidth()" [height]="imageHeight()" />
  </div>
}

@if (title(); as t) {
  <div class="heading">{{ t }}</div>
}

@if (desc(); as d) {
  <div class="subheading" [innerHTML]="d | rtPreventOrphans"></div>
}

<div class="content">
  <ng-content />
</div>
